import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { iconExpansionPanelCaret } from '../../svg-icons';
import { IconManager } from '../../services/icon-manager.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'twc-expandable-panel',
  imports: [CommonModule, MatExpansionModule, MatIconModule, MatButtonModule],
  templateUrl: './expandable-panel.component.html',
  styleUrl: './expandable-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandablePanelComponent {
  private _iconManagerService = inject(IconManager);

  expanded = model<boolean>(false);
  disabled = input<boolean>();

  titleTemplate = input<TemplateRef<any>>();
  metaTextTemplate = input<TemplateRef<any>>();

  defaultIconName = input.required<string>();
  activeIconName = input<string>();
  defaultIconColorClass = input<string>();
  activeIconColorClass = input<string>();
  defaultIconWrapperBgClass = input<string>();
  activeIconWrapperBgClass = input<string>();

  constructor() {
    this._iconManagerService.addIcons([
      {
        name: 'caret',
        icon: iconExpansionPanelCaret,
      },
    ]);
  }

  toggle() {
    if (!this.disabled()) this.expanded.update((expanded) => !expanded);
  }
}
